module.exports = __webpack_public_path__ + "img/selected6-min.a3ec3c3b.png";